import { Vista } from "@essenza/react";
import { useModel, useVista, useGraph, useApp } from "@essenza/react";
import { Col, Input, Row, Select } from "antd";
import { useEffect, useRef } from "react";
import { RoleModel, SkillModel } from "../models/DBModel";
import { CandidateModel } from "../models/jobmodel";
import { CandidateList } from "../view/CandidateList";
import { SearchOutlined } from '@ant-design/icons';

const { Option } = Select;

export function AllCandiateVistaVistaController(c) {
    c.skin = AllCandiateVista;
    let store = null;
    c.command = {
        SEARCH: (list, { data }) => {
            if (!store)
                store = list;
            const txt = data.text.toLowerCase();
            const hasSkill = (skills, id) => {
                let found;
                for (let k = 0; k < id.length; k++) {
                    found = false;
                    for (let z = 0; z < skills.length; z++) {
                        if (id[k] === skills[z]) { found = true; break; };
                    }
                    if (!found) return false;
                }
                return true;
            }
            c.setSource("users.all", store.filter((item) => (data.role === '' || item[data.role]) && (data.skill.length === 0 || (item.jskills && hasSkill(item.jskills, data.skill))) && (txt === '' || (item.tsurname?.toLowerCase() + ' ' + item.tname?.toLowerCase()).indexOf(txt) > -1)
            ));
        }
    }
}

export function AllCandiateVista(info) {
    const [ctx, control] = useVista(AllCandiateVistaVistaController);
    const [model] = useModel();
    const candidate = useGraph(CandidateModel, "all");
    const skills = useGraph(SkillModel, "list");
    const roles = useGraph(RoleModel, "list");
    const filter = useRef({ role: '', skill: [], text: '' }).current;

    useEffect(() => {
        console.log("MODEL ", model);
        if (model) {
            model.read(CandidateModel, m => m.all());
        }
    }, [model]);

    console.log("CANDIDATE-LIST-VISTA");

    return (
        <Vista context={ctx} >
            <div className="w100 py-md">
                <div className="centered padding-md ">
                    <Row wrap={false}> 
                        <Col flex="300px"  >
                            <div className="padding-md bg-pri round-sm custom-form">
                                <Input style={{ height: '46px', backgroundColor: '#EDEDED', width: '100%', padding: '0 0 0 6px', margin: '0' }} onChange={(e) => { filter.text = e.currentTarget.value; control.execute("SEARCH", candidate.data, filter) }} placeholder="Cerca candidato" />
                                <Select className="mt-sm" onChange={(v) => { filter.role = v; control.execute("SEARCH", candidate.data, filter) }} placeholder="Che figura stai cercando" style={{ width: '100%', height: '46px', padding: '0' }}>
                                    <Option value="">Tutte le figure</Option>
                                    {Array.isArray(roles.data) && roles.data.map((v) => <Option value={v.code}>{v.name}</Option>)}
                                </Select>
                                <Select className="mt-sm" mode="multiple" allowClear style={{ width: '100%', }} placeholder="Seleziona Skills"
                                    onChange={(v) => { filter.skill = v; control.execute("SEARCH", candidate.data, filter) }}>
                                    {skills.data ? skills.data.map((item) => <Option value={item.id}>{item.name}</Option>) : null}
                                </Select>
                            </div>
                        </Col>
                        <Col flex="auto" className="pl-media mt-sm">
                            <h2>Ricerca Candidati</h2>
                            <CandidateList column={false} source={candidate?.get()} />
                        </Col>
                    </Row>
                </div>
            </div>
        </Vista>
    )
}